const questions = [
  {
    id: 0,
    questionLabel: "Finantsseis",
    sliderQuestion: "1. Kui rahul sa oled hetkel enda finantsseisuga?",
    textQuestion:
      "Mis on sinu suurim saavutus või suurim väljakutse? Millist toetust sa vajaksid väljakutsega toimetulekuks?",
  },
  {
    id: 1,
    questionLabel: "Tervis",
    sliderQuestion: "2. Kui rahul sa oled hetkel oma tervisega?",
    textQuestion: "Mis on sinu suurim väljakutse või suurim saavutus?",
  },
  {
    id: 2,
    questionLabel: "Eneseareng",
    sliderQuestion: "3. Kui rahul sa oled hetkel oma enesearengu teekonnaga?",
    textQuestion:
      "Mis on sinu suurim väljakutse või suurim saavutus enesearengu teekonnal?",
  },
  {
    id: 3,
    questionLabel: "Karjäär",
    sliderQuestion: "4. Kui rahul sa oled hetkel enda karjääriga?",
    textQuestion:
      "Mis on sinu suurim väljakutse või suurim saavutus karjääri teekonnal?",
  },
  {
    id: 4,
    questionLabel: "Enesekindlus",
    sliderQuestion:
      "5. Kuidas hindad hetkel enda enesekindlust asjadega alustamises, tegutsemises ja lõpuni viimises?",
    textQuestion: "Mis on sinu suurim väljakutse või suurim saavutus?",
  },
  {
    id: 5,
    questionLabel: "Suhted",
    sliderQuestion:
      "6. Kuidas hindad oma suhteid tööl, peres, tutvusringkonnas ja iseendaga?",
    textQuestion:
      "Mis on sinu suurim väljakutse või suurim saavutus suhete hoidmisel ja loomisel?",
  },
];

export { questions };
